var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"full-link",attrs:{"href":_vm.valueHandler,"title":_vm.valueHandler,"target":"_blank"}},[_c('i',{staticClass:"fas fa-external-link-alt"})])}
var staticRenderFns = []

export { render, staticRenderFns }